import Vue from 'vue';
import warehouseTransformer from './../../transformers/warehouseProduct';
import paginationTransformer from '../../transformers/pagination';
import store from '../../store';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const products = warehouseTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedWarehouseProducts', { products, pagination });
  resolve({ products, pagination });
  // store.dispatch('fetchCurrentWarehouseProducts', products);
};

const failed = () => {};

export default (id, params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl(`/warehouses/products/${id}`, params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/products.js